import imgVoiture2 from '../../../ASSETS/tourisme/Image/Voiture.jpg'
import imgVoiture3 from '../../../ASSETS/tourisme/Image/voiture3.jpg'
import imgVoiture from '../../../ASSETS/tourisme/Image/voiture2.jpg'
import * as React from 'react';
import { GiMoneyStack } from "react-icons/gi";
import {Link} from 'react-router-dom'
import Footer from '../../COMPONENTS/Footer/Footer'
import { useState, useEffect } from 'react';
import Loading from '../../COMPONENTS/Loading/Loading'
import BarniereLvoiture from './BarniereLvoiture';
import BackImage from './BackImage';
import Location from '../../../API/tourisme/location/index'
import { AnnoncesProps} from "../../../props";
import { useTranslation } from 'react-i18next';
import { ResultContext } from '../../../ResultContext';


function Lvoiture() {

  const [loading, setLoading] = useState(true);

  const [loc, setLoc] = useState<AnnoncesProps[]>([]);

  const [transmission, setTransmission] = useState('');
  const [consommation, setConsommation] = useState('');
  const [lieu, setLieu] = useState('');
  const [prix, setPrix] = useState('');
  const [min,setMin] = useState('');
  const contexts = React.useContext(ResultContext)
  

  // Filtrer la liste des voitures en fonction des filtres
  const filteredLoc = loc.filter((list) => {
    return (
      (transmission === '' || list.car_transmission === transmission) &&
      (consommation === '' || list.car_fuel_type === consommation) &&
      (lieu === '' || list.contact_address.toLowerCase().includes(lieu.toLowerCase())) &&
      (prix === '' || list.price_announce <= parseFloat(prix)) &&
      (min === '' || list.price_announce > parseFloat(min))
    );
  });
  let code = localStorage.getItem('code') ? localStorage.getItem('code') : localStorage.getItem('is_code');
  const getAllVehicule = () => {
    Location.getAllData(code)
    .then((res:any) => {
      //console.log(res)
        if (res.data.status === 200 && contexts?.results.voiture === null) {
          setLoc(res.data.data)
        }
    })
    .catch((err:any) => {
        console.log(err);
    })
    .finally(() => {
        setLoading(false);
    })
}
function truncate (str : any) {
  return str.length > 200 ? str.substring(0, 200) + "..." : str;
}

  useEffect(() => {

    getAllVehicule();

    //const timer = setTimeout(() => {
      // Après 5 secondes, masquer le spinner et rediriger l'utilisateur
      //setLoading(false);
    //}, 2000); // 5000 millisecondes = 5 secondes

    // Nettoyer le timer si le composant est démonté avant la fin du délai
    //return () => clearTimeout(timer);
  }, []);

   useEffect(()=>{
      if(contexts?.results.voiture)
      {
        //const initialItemsArray = contexts?.results.resto.slice(0, 5);
        //const shuffledInitialItems = [...initialItemsArray].sort(() => Math.random() - 0.5);
        setLoc(contexts?.results.voiture)
      }
    },[contexts?.results.voiture])

  const {t} = useTranslation() as {t:(key:string)=>string}
  let authUser: { userId: number } | null = JSON.parse(localStorage.getItem('data') || 'null');

   
  return (
    <div>
      {loading ? (
        // Afficher le spinner tant que loading est true
        <Loading />
      ) : (
        <>
          
          <BackImage/>
          
            {/* Filtre */}
      <div className='grid gap-6 pt-10 md:grid-cols-3 xs:grid-cols-2 s:grid-cols-1 place-items-center'>
        <button
          className='md:w-[400px] sm:w-[300px] s:w-[300px] h-10 bg-[#233D4D] text-lg py-15 text-white rounded hover:bg-white hover:text-[#233D4D] transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 duration-300'
          onClick={() => {
            setTransmission('');
            setConsommation('');
            setLieu('');
            setPrix('');
          }}
        >
          {t("Tout")}
        </button>
        {/* Type de véhicule */}
        <select
          className='border-[#233D4D] border-2 sm:w-[300px] s:w-[300px] md:w-[400px] px-3 h-10 rounded text-lg'
          value={transmission}
          onChange={(e) => setTransmission(e.target.value)}
        >
          <option value=''>{t("Transmission automobile")}</option>
          <option value='automatic'>{t("Automatique")}</option>
          <option value='manual'>{t("Manuel")}</option>
          <option value='hybrid'>{t("Hybride")}</option>
        </select>
        {/* Marque du véhicule */}
        <select
          className='border-[#233D4D] border-2 sm:w-[300px] s:w-[300px] md:w-[400px] px-3 h-10 rounded text-lg'
          value={consommation}
          onChange={(e) => setConsommation(e.target.value)}
        >
          <option value=''>{t("Type de consommation")}</option>
          <option value='diesel'>{t("Diesel")}</option>
          <option value='essence'>{t("Essence")}</option>
          <option value='electrique'>{t("Electrique")}</option>
        </select>
        {/* Lieu où la voiture se trouve */}
        <input
          type='text'
          name='lieu_voiture'
          placeholder={t("Lieu")}
          className='border-[#233D4D] border-2 sm:w-[300px] s:w-[300px] md:w-[400px] px-3 h-10 rounded text-lg'
          value={lieu}
          onChange={(e) => setLieu(e.target.value)}
        />

        <input
          type='text'
          name='prix_voiture'
          placeholder={t("Min Prix")}
          className='border-[#233D4D] border-2 sm:w-[300px] s:w-[300px] md:w-[400px] px-3 h-10 rounded text-lg'
          value={min}
          onChange={(e) => setMin(e.target.value)}
        />
        
        {/* Prix de la voiture */}
        <input
          type='text'
          name='prix_voiture'
          placeholder={t("Max Prix")}
          className='border-[#233D4D] border-2 sm:w-[300px] s:w-[300px] md:w-[400px] px-3 h-10 rounded text-lg'
          value={prix}
          onChange={(e) => setPrix(e.target.value)}
        />
      </div>
          {/* container 1 */}
          <div className='grid py-20 xs:grid-cols-2 md:grid-cols-4 md:gap-2 xs:gap-8 s:gap-y-8 s:grid-cols-1 place-items-center '>
            
          {filteredLoc.map((list, index )=> (
                    <div key={index} className='flex flex-col transition duration-300 ease-in-out delay-150 cursor-pointer hover:-translate-y-1 hover:scale-110 '>
                        <Link to="/Locationdevehicule/Voiture/#voir-plus" state={list.id_announce}>
                          {/* image de voiture */}
                          <img className='rounded-md shadow-xl xs:w-72 sm:w-64 xs:h-52 lg:h-60 sm:h-52' src={`data:image/png;base64,${list[0]}`} alt={list.title_announce}/>
                          {/* bloc blanc description de la voiture */}
                          <div className='h-full px-4 pb-6 bg-white border-l-4 border-yellow-400 shadow-xl xs:w-72 sm:w-64 md:space-y-2 sm:space-y-0'>
                            <div className='bg-[#3ec53e] text-white w-[90px] h-6 text-center relative bottom-6  s:left-[146px] xs:left-[178px]'>Disponible</div>
                                <div className='flex items-center space-x-2 sm:text-xs'>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16.52" height="40.28" viewBox="0 0 67.52 101.28">
                                    <g id="localisation" transform="translate(-85.333)">
                                        <path id="Tracé_269" data-name="Tracé 269" d="M119.093,0A33.764,33.764,0,0,0,89.386,49.8l27.861,50.388a2.11,2.11,0,0,0,3.692,0L148.81,49.787A33.766,33.766,0,0,0,119.093,0Zm0,50.64a16.88,16.88,0,1,1,16.88-16.88A16.9,16.9,0,0,1,119.093,50.64Z" fill="#233d4d"/>
                                    </g>
                                    </svg>
                                    <div className='text-base font-thin '>{list.contact_address}</div>
                                </div>
                                

                              <div className='font-medium text-orange-400 md:text-lg lg:text-lg sm:text-sm'>{list.title_announce}</div>
                              <div>
                              <p>{truncate(list.description_announce)} </p>
                              </div>
                              <hr className='sm:pb-1 lg:pb-0'/>
                              {/* prix */}
                              <div className='flex items-center py-2 space-x-2 '>
                                <GiMoneyStack className='text-lg' />
                                <p className='sm:text-xs md:text-base'> Prix : {list.price_announce} FCFA / jour</p>
                              </div>
                              {list.status === "enabled" &&  authUser && authUser.userId !== list?.made_by && (
                                  <Link to='/Reservation_Vehicule' state={ 
                                    list.id_announce 
                                }>
                                  <button className='bg-[#233D4D] text-white w-[200px] relative left-6 h-8  rounded  
                                              justify-center cursor-pointer transition ease-in-out delay-150 
                                              hover:-translate-y-1 hover:scale-110 duration-300 flex items-center space-x-2 '>
                                    Faire une reservation
                                  </button>
                                </Link>
                                  )}
                              
                          </div>
                        </Link>
                    </div>
              )
          )}
          </div>

          {/* Container 2 */}
          <BarniereLvoiture/>
       
          <Footer/>
        </>
      )}
    </div>
  )
}

export default Lvoiture